import React, { useState } from 'react'
import { API_URL } from '../../../utils'
import FileIcon from '../../../components/file-manager/FileIcon'
import { useTranslation } from 'react-i18next'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { FilePreviewModal, isPreviewable, getPreviewFileType } from '@/components/file-preview'
import { Download, Eye, FileText } from 'lucide-react'
import { formatBytes } from '../../../components/grid/formatters'

const BidsFiles = ({ files, tenderStatus }) => {
  const { t } = useTranslation()
  const [previewFiles, setPreviewFiles] = useState([])
  const [previewIndex, setPreviewIndex] = useState(null)

  if (!files || files.length === 0) {
    return <span className="text-muted-foreground">—</span>
  }

  // During running tender, show count but don't allow opening
  if (tenderStatus === 'RUNNING') {
    return (
      <span className="flex items-center gap-1.5 text-sm text-muted-foreground">
        <FileText className="h-3.5 w-3.5" />
        <span>{files.length}</span>
      </span>
    )
  }

  return (
    <>
      <Popover>
        <PopoverTrigger asChild>
          <button className="flex items-center gap-1.5 text-sm hover:text-primary transition-colors">
            <FileText className="h-3.5 w-3.5 text-muted-foreground" />
            <span>{files.length}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-80 p-0">
          <div className="px-3 py-2 border-b">
            <p className="text-sm font-medium">{t('Tender_bids_table_column_files')} ({files.length})</p>
          </div>
          <div className="max-h-60 overflow-y-auto divide-y">
            {files.map((file) => {
              const canPreview = file.mimetype && isPreviewable(file.mimetype)
              const handlePreview = () => {
                const previews = files
                  .filter((f) => f.mimetype && isPreviewable(f.mimetype))
                  .map((f) => ({
                    url: `${API_URL}/download/${f.id}`,
                    title: f.filename,
                    downloadUrl: `${API_URL}/download/${f.id}`,
                    type: getPreviewFileType(f.mimetype),
                    fileId: f.id,
                    fileSize: f.size,
                  }))
                const idx = previews.findIndex((p) => p.fileId === file.id)
                setPreviewFiles(previews)
                setPreviewIndex(idx >= 0 ? idx : 0)
              }

              return canPreview ? (
                <button
                  key={file.id}
                  onClick={handlePreview}
                  className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-muted transition-colors w-full text-left"
                >
                  <FileIcon filename={file.filename} />
                  <div className="min-w-0 flex-1">
                    <p className="truncate">{file.filename}</p>
                    <p className="text-xs text-muted-foreground">{formatBytes(file.size)}</p>
                  </div>
                  <Eye className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
                </button>
              ) : (
                <a
                  key={file.id}
                  href={`${API_URL}/download/${file.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-3 py-2 text-sm hover:bg-muted transition-colors"
                >
                  <FileIcon filename={file.filename} />
                  <div className="min-w-0 flex-1">
                    <p className="truncate">{file.filename}</p>
                    <p className="text-xs text-muted-foreground">{formatBytes(file.size)}</p>
                  </div>
                  <Download className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
                </a>
              )
            })}
          </div>
        </PopoverContent>
      </Popover>
      {previewFiles.length > 0 && previewIndex !== null && (
        <FilePreviewModal
          isOpen={true}
          files={previewFiles}
          currentIndex={previewIndex}
          onNavigate={setPreviewIndex}
          onClose={() => setPreviewIndex(null)}
        />
      )}
    </>
  )
}
export default BidsFiles
